import { useTranslate } from '@tolgee/react'
import { Header } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'

export const VesselBookingHeader = observer(() => {
  const { t } = useTranslate()

  // const onCreateBooking = async () => {
  // }

  return (
    <Header
      title={t('vesselBookings', 'Vessel bookings')}
      // rightRenderOption={
      //   <Box flex='none'>
      //     <Button
      //       key='createAppointment'
      //       variant='contained'
      //       onClick={onCreateBooking}
      //       data-cy='create-booking-btn'
      //     >
      //       {t('createBooking', 'Create booking')}
      //     </Button>
      //   </Box>
      // }
    />
  )
})
